import { render, staticRenderFns } from "./BandedSection.vue?vue&type=template&id=1b2bbe12"
import script from "./BandedSection.vue?vue&type=script&lang=js"
export * from "./BandedSection.vue?vue&type=script&lang=js"
import style0 from "./BandedSection.vue?vue&type=style&index=0&id=1b2bbe12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports